import React from "react";
import Sidebar from "@/components/Sidebar";
import Topbar from "@/components/Topbar";
import ConnectionBanner from "@/components/ConnectionBanner";
import { Toaster } from "sonner";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#050B14] text-slate-100">
      <Sidebar />
      <Topbar />
      <ConnectionBanner />
      <main className="ml-64 pt-0 min-h-[calc(100vh-56px)] p-6 grid-bg">
        {children}
      </main>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#0E1522",
            color: "#F1F5F9",
            border: "1px solid #1E293B",
            borderRadius: 0,
            fontFamily: "IBM Plex Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}
